import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import GameServices from "./GameServices";
import Common from "../based/Common";

function AddressSystemHistoryModal({ show, onClose, interfaceName }) {
    const [listHistoryIP, setListHistoryIP] = useState([]);

    console.log("listHistoryIP :>> ", listHistoryIP);

    useEffect(() => {
        if (show && interfaceName) {
            getListHistory(interfaceName);
        }
    }, [show, interfaceName]);

    const getListHistory = async (interfaceName) => {
        const [err, data] = await GameServices.GetListIpByInterface(interfaceName);
        if (!err && data) {
            setListHistoryIP(data);
        } else {
            setListHistoryIP([]);
        }
    };

    return (
        <CommonModal show={show} onClose={onClose}>
            <Wrapper>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className="center">STT</th>
                            <th className="center">IP</th>
                            <th className="center">Interface</th>
                            <th className="center">Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listHistoryIP && listHistoryIP.length > 0 ? (
                            listHistoryIP.map((x, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{x.ip}</td>
                                        <td>{x.name}</td>
                                        <td>{Common.formatDate(new Date(x.createdDate), "fulldate")}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={1000} className="center">
                                    Không có dữ liệu
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </Wrapper>
        </CommonModal>
    );
}

export default AddressSystemHistoryModal;

const Wrapper = styled.div``;
